import "./ImageMore.scss";

import React from "react";
import { FaSearchPlus } from "react-icons/fa";
import {useLayerPopupContext} from "../../../contexts";

interface Props {
  src: string;
  children: React.ReactNode;
}

const ImageMore = ({ src, children }: Props) => {
  const { image: { handleImage }, open } = useLayerPopupContext()

  return (
    <div
      className="chat__image"
      onClick={() => {
        handleImage({url: src});
        open("IMAGE");
      }}
    >
      <div className="chat__image--more">
        <FaSearchPlus className="chat__image--expand" />
      </div>
      {children}
    </div>
  );
};

export default ImageMore;
